import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  assignedEngineerEmail?: string;
};

type Props = {
  form: UseFormReturn;
};

function WorkForceSearch({ form }: Props) {
  const { t } = useTranslation('global');
  return (
    <Box>
      <Typography>{t('common.commonProperties.fieldEngineer')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="assignedEngineerEmail"
        placeholder={t('common.commonProperties.fieldEngineer')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('common.commonProperties.valueLessThan1')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default WorkForceSearch;
